import React from 'react';

import DemographicsPage from './DemographicsPage';

async function action(context, params) {
  const { section } = params;
  return {
    title: 'Demographics',
    chunks: ['help'],
    component: <DemographicsPage section={section} />,
  };
}

export default action;
